import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { DatePicker, DateTimePicker } from '@material-ui/pickers';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import FormLabel from "@material-ui/core/FormLabel";
import cx from 'classnames';

const styles = (theme) => ({
  bootstrapFormLabel: {
    display: 'block',
    marginBottom: 8,
    color: theme.palette.text.primary,
  },
  input: {
    backgroundColor: theme.palette.action.disabledBackground
  },
  margin: {
    marginBottom: theme.spacing(3),
  },
});

class DateInput extends PureComponent {
  render() {
    const {
      hasError,
      helpText,
      value,
      onChange,
      label,
      classes,
      fullWidth,
      disableMargin,
      time,
      ...otherProps
    } = this.props;

    const Component = time ? DateTimePicker : DatePicker;

    return (
     <FormControl fullWidth={fullWidth} className={cx(classes.root, !disableMargin && classes.margin)}>
       {label && (
         <FormLabel component="label" className={classes.bootstrapFormLabel}>{label}</FormLabel>
       )}
       <Component
         autoOk
         className={classes.input}
         InputAdornmentProps={{ position: "start" }}
         value={value ? moment(value) : null}
         onChange={v => onChange(v ? v.toDate() : null)}
         error={hasError}
         helperText={helpText}
         {...otherProps}
       />
     </FormControl>
    );
  }
}

DateInput.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  format: PropTypes.string,
};

DateInput.defaultProps = {
  id: 'input',
};

export default withStyles(styles)(DateInput);
